<app-main-nav></app-main-nav>
<section>
<router-outlet></router-outlet>
<app-splash-screen></app-splash-screen>
</section>
<app-footer></app-footer>